

import { createSlice } from "@reduxjs/toolkit";

export const dataVentaSlice = createSlice({
    name: 'dataVentaStore',
    initialState: {
        value: []
    },
    reducers: {
        setDataVentaStore: (state, action) => {
            state.value = action.payload
        }
    }
})

export const { setDataVentaStore } = dataVentaSlice.actions

export default dataVentaSlice.reducer